export const SPORT_STANDINGS_TABLE_TEST_IDS = {
  root: 'sport-standings-table',
  header: 'sport-standings-table-header',
  empty: 'sport-standings-table-empty',
  headerCellPrefix: 'sport-standings-header-',
  rowPrefix: 'sport-standings-row-',
  cellPrefix: 'sport-standings-cell-',
} as const;
